import React                       from 'react';
import { bomLineItems as tooltip } from 'pu-data/Tooltips';
import TextComponent               from './TextComponent';

const BomLineItems = (props) => {
  const name = 'bom_line_items';
  const onChange = (e) => props.onChangeParameter(name, e.target.value);
  return (
    <TextComponent
      label="Unique # of parts (BOM line items)"
      name={name}
      inputId={props.inputId}
      value={props.parameters[name] || ''}
      required={props.required}
      onChange={onChange}
      tooltip={tooltip}
      groupName={props.groupName}
      errorMessage={props.errorMessage} />
  );
};

BomLineItems.defaultProps = {
  required: true,
  inputId : 'bom-line-items',
};

export default BomLineItems;
